import React from "react";
import { Link } from "react-router-dom";
import {
  HOME_CTA_DARK_OUTLINE,
  HOME_CTA_DARK_PRIMARY,
  HOME_CTA_OUTLINE,
  HOME_CTA_PRIMARY,
} from "../../lib/homeCta";
import { useShellTheme } from "../layout/ShellTheme";

/** End-of-page conversion strip — used on learn + product pages. */
export default function ConversionCtas() {
  const dark = useShellTheme() === "dark";

  return (
    <section
      className={
        dark
          ? "mt-16 rounded-3xl border border-white/14 bg-panel/80 px-6 py-8 md:px-10 md:py-10 text-center"
          : "mt-16 rounded-3xl border border-cream bg-gradient-to-br from-white to-cream/40 px-6 py-8 md:px-10 md:py-10 text-center"
      }
      aria-label="Next steps"
    >
      <p className={`text-[10px] tracking-[0.25em] uppercase ${dark ? "text-sage/70" : "text-botanical/60"}`}>
        Take the next step
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-3">
        <Link to="/shop" className={`${dark ? HOME_CTA_DARK_PRIMARY : HOME_CTA_PRIMARY} px-6 py-3 text-sm`}>
          Shop Moss Matrix
        </Link>
        <Link to="/reviews" className={`${dark ? HOME_CTA_DARK_OUTLINE : HOME_CTA_OUTLINE} px-6 py-3 text-sm`}>
          Reviews
        </Link>
        <Link to="/learn" className={`${dark ? HOME_CTA_DARK_OUTLINE : HOME_CTA_OUTLINE} px-6 py-3 text-sm`}>
          Learn
        </Link>
      </div>
    </section>
  );
}
